import { NeighborhoodServiceAreaInfo } from 'rwl-shared/dist/models';

const MAX_SERVICE_AREA_DISTANCE = 100;

export const filterServiceAreas = (
    serviceAreas: NeighborhoodServiceAreaInfo[],
    accountGeolocation?: google.maps.LatLngLiteral
): NeighborhoodServiceAreaInfo[] => {
    if (!serviceAreas?.length) return [];

    // Prefer the passed-in geolocation...
    let center = accountGeolocation;

    // ...otherwise, pick the service area with the highest jobCount that has a valid location.
    if (!center) {
        const validAreas = serviceAreas.filter(
            (a) => a.placeInfo?.geometry?.location
        );
        if (!validAreas.length) return [];

        const largestArea = validAreas.reduce((acc, curr) =>
            curr.jobCount > acc.jobCount ? curr : acc
        );
        center = largestArea.placeInfo?.geometry?.location;
    }

    if (!center?.lat || !center?.lng) return [];

    // Filter service areas within MAX_SERVICE_AREA_DISTANCE
    return serviceAreas.filter((area) => {
        const location = area.placeInfo?.geometry?.location;
        if (!location) return false;

        const distance = getDistanceFromLatLonInMiles(
            center!.lat,
            center!.lng,
            location.lat,
            location.lng
        );
        return distance <= MAX_SERVICE_AREA_DISTANCE;
    });
};

function getDistanceFromLatLonInMiles(
    lat1: number,
    lon1: number,
    lat2: number,
    lon2: number
): number {
    const R = 3958.8; // Radius of the Earth in miles
    const dLat = ((lat2 - lat1) * Math.PI) / 180; // Convert degrees to radians
    const dLon = ((lon2 - lon1) * Math.PI) / 180;
    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos((lat1 * Math.PI) / 180) *
            Math.cos((lat2 * Math.PI) / 180) *
            Math.sin(dLon / 2) *
            Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c; // Distance in miles
    return distance;
}
